// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"design-brand-book_wrapper__fNJ3U","title":"design-brand-book_title__GGPb4","text":"design-brand-book_text__TK7NS","image":"design-brand-book_image__TWEtN"};